import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { fold } from "../../../../helpers/chartHelper";
import { adjustContentHeight } from "../../../../helpers/viewPortHelper";

export const BarChart = ({ data, size, autoFit = false, questionName, categories, template, showPercent = false, showCount = false, presentationOrder }) => {
  let dataArr = [];
  let colors = [];
  if (template.chart.colors) {
    colors = [template.chart.colors.color1, template.chart.colors.color2, template.chart.colors.color3, template.chart.colors.color4, template.chart.colors.color5];
  }
  let colorI = 0;
  let totalCount = 0;
  for (const a of data) {
    totalCount += 1 * a.weight;
  }
  categories.map((d) => {
    let count = 0;
    for (const a of data.filter((c) => c.answer === d)) {
      count += 1 * a.weight;
    }
    if (colorI == 4) colorI = 0;
    else colorI++;
    if (!dataArr.find((da) => da.name === d && (d !== null || d !== ""))) {
      dataArr.push({
        name: d,
        y: showPercent ? (count / totalCount) * 100 : count,
        percentage: `${(count / totalCount) * 100}`,
        count:`${count}`,
        color: colors[colorI],
        sliced: true,
      });
    }
  });

  if (presentationOrder == "VOTES") {
    dataArr.sort((a, b) => {
      return b.y - a.y;
    });
  }

  let w = window.innerWidth * (parseInt(template.content.maxWidth) / 100);
  let h = adjustContentHeight(window.innerHeight, template.content, template.header, template.footer);
  questionName = questionName.length > 50 ? fold(questionName, 50, true).join("<br/>") : questionName;
  const options = {
    chart: {
      backgroundColor: "transparent",
      plotBorderWidth: null,
      plotShadow: false,
      plotBackgroundColor: "transparent",
      type: "bar",
      height: autoFit && size ? size.height * 0.9 : h,
      width: autoFit && size ? size.width * 0.9 : w * 0.9,
    },
    title: {
      text: questionName,
      style: {
        fontSize: autoFit ? "2vh" : template.title.fontSize,
        fontFamily: template.title.fontFamily,
        color: template.title.color,
        textAlign: autoFit ? "left" : "center",
      },
    },
    legend: {
      enabled: false,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      max: showPercent ? 100 : null,
      allowDecimals: false,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: autoFit ? "1.5vh" : template.label.fontSize,
          fontFamily: template.label.fontFamily,
          color: template.label.color,
        },
      },
    },
    xAxis: {
      categories: dataArr.map((d) => {
        return d.name;
      }),
      allowDecimals: false,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: autoFit ? "1.5vh" : template.label.fontSize,
          fontFamily: template.label.fontFamily,
          color: template.label.color,
        },
        formatter: function () {
          var ret = this.value,
            len = ret.length;
          let str = ret;
          if (len > 40) {
            for (let index = Math.round(len / 2); index < len; index++) {
              if (ret[index] == " ") {
                return ret.slice(0, index) + "<br/>" + ret.slice(index + 1);
              }
            }
          }
          return str;
        },
      },
    },
    tooltip: {
      /*  pointFormat: "<br>{point.percentage:.1f} %", */
      formatter: function () {
        return "" + this.point.name + ": " + this.point.y.toFixed(2) + (showPercent ? "%" : "");
      },
    },
    plotOptions: {
      series: {
        stacking: "normal",
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        dataLabels: {
          style: {
            fontSize: autoFit ? "1.3vh" : "1.3rem",
            fontFamily: template.label.fontFamily,
            color: template.label.color,
            backgroundColor: "red",
          },
          enabled: true,
          formatter: function () {
            var pcnt = (this.y / dataArr.map((p) => p.y).reduce((a, b) => a + b, 0)) * 100;
            if(showPercent && showCount) return `${Math.round(pcnt)}% (${this.point.count})`
            else if(showPercent && !showCount) return `${Math.round(pcnt)}%`
            else if(!showPercent && showCount) return `${this.point.count}`
            else return ""
          },
        },
        colorByPoint: true,
        data: dataArr.map((a, b) => {
          return a;
        }),
        showInLegend: false,
      },
    ],
  };

  return (
    <React.Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </React.Fragment>
  );
};
